import React from 'react';

import Button from '@atlaskit/button';

import { messages } from '@qality/common-messages';

import './_test-case-box-steps-actions.scss';

type Props = {
  canEdit: boolean;
  addTestStep: () => Promise<boolean | void>;
};

export default function TestCaseBoxStepsActions({
  canEdit,
  addTestStep,
}: Props): JSX.Element {
  return (
    <div className='test-case-box-steps-action'>
      <Button onClick={addTestStep} onFocus={addTestStep} isDisabled={!canEdit}>
        {messages['testCaseBoxActions.add.label']}
      </Button>
    </div>
  );
}
